import React from "react";
import AlignContent from "./components/AlignContent";
import AlignItems from "./components/AlignItems";
import FlexDirection from "./components/FlexDirection";
import FlexWrap from "./components/FlexWrap";
import Footer from "./components/Footer";
import Header from "./components/Header";
import JustifyContent from "./components/JustifyContent";
import Note from "./components/Note";
import ToastMessage from "./components/ToastMessage";
import { ToastProvider } from "./context/toast";

const App = () => {
  return (
    <ToastProvider>
      <div className="main-container">
        <Header />
        <Note
          label={"Properties for the Parent (flex container)"}
          text={
            "don’t forget to set the container display to flex or inline-flex :)"
          }
        />
        <FlexDirection />
        <FlexWrap />
        <JustifyContent />
        <AlignContent />
        <AlignItems />
        <Footer />
        <ToastMessage />
      </div>
    </ToastProvider>
  );
};

export default App;
